/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_TabletsInputs */

const he_home_category_tablets = /** @type {(inputs: Home_Category_TabletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טאבלטים`)
};

const en_home_category_tablets = /** @type {(inputs: Home_Category_TabletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tablets`)
};

/**
* | output |
* | --- |
* | "Tablets" |
*
* @param {Home_Category_TabletsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_tablets = /** @type {((inputs?: Home_Category_TabletsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_TabletsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_tablets(inputs)
	return en_home_category_tablets(inputs)
});